<template>
  <div class="donut-wrap">
    <apexchart
      type="donut"
      :options="chartOptions"
      :series="series"
      width="190"
      height="190"
    />
  </div>
</template>

<script>
export default {
  props: {
    segments: { type: Array, required: true }
  },

  computed: {
    series() {
      return this.segments.map(s => s.count);
    },
    total() {
      return this.series.reduce((a, b) => a + b, 0);
    },
    chartOptions() {
      return {
        labels: this.segments.map(s => s.label),
        colors: this.segments.map(s => s.color),
        dataLabels: { enabled: false },
        legend: { show: false },
        stroke: { width: 0 },
        plotOptions: {
          pie: { donut: { size: '72%' } }
        }
      };
    }
  }
};
</script>